<template>
  <div>
    <a-spin :spinning="loading">
      <a-form layout="horizontal" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }" @keyup.enter.native="loadData">
        <a-row :gutter="24">
          <a-col :md="8" :sm="12">
            <a-form-item :label="$t('platformCollection.date')">
              <a-range-picker
                v-model="queryParam.date"
                :disabled-date="disabledDate"
                @calendarChange="handleChange"
                @blur="handleBlur"
                format="YYYY-MM-DD"
                style="width: 100%"
              />
            </a-form-item>
          </a-col>

          <a-col :md="8" :sm="12">
            <a-form-item :label="$t('platformCollection.department')">
              <a-select style="width: 100%" v-model="queryParam.departmentId" @change="onChangeOne">
                <a-select-option :value="null"> {{ $t('platformCollection.all') }} </a-select-option>
                <a-select-option v-for="item in departmentList" :key="item.id">
                  {{ item.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :md="8" :sm="12">
            <a-form-item :label="$t('platformCollection.grouping')">
              <a-select style="width: 100%" v-model="queryParam.groupId" @change="onChangeTwo">
                <a-select-option :value="null"> {{ $t('platformCollection.all') }} </a-select-option>
                <a-select-option v-for="item in groupList" :key="item.id">
                  {{ item.groupName }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :md="8" :sm="12">
            <a-form-item :label="$t('platformCollection.name_of_collector')">
              <a-select style="width: 100%" v-model="queryParam.userId">
                <a-select-option :value="null"> {{ $t('platformCollection.all') }} </a-select-option>
                <a-select-option v-for="item in userList" :key="item.id">
                  {{ item.userName }}
                  <span style="float: right; color: #8492a6; font-size: 13px">{{ item.mobile }}</span>
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :md="8" :sm="12">
            <a-form-item :label="$t('platformCollection.collection_stage')">
              <a-select style="width: 100%" v-model="queryParam.normalConfigId">
                <a-select-option :value="null"> {{ $t('platformCollection.all') }} </a-select-option>
                <a-select-option v-for="item in normalConfigList" :key="item.id">
                  {{ item.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :md="8" :sm="12">
            <a-form-item class="table-page-search-submitButtons">
              <a-button type="primary" @click="loadData(1)" icon="search">{{ $t('search') }}</a-button>
              <a-button type="primary" @click="downLoadData" icon="download" style="margin-left: 8px">{{
                $t('exportFile')
              }}</a-button>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </a-spin>
    <div class="tableBox" style="margin-top: 30px; margin-bottom: 30px">
      <a-table :pagination="false" :dataSource="dataSource" :columns="columns" bordered>
        <template #footer>
          <div class="totalBox">
            <div>
              <h4>{{ $t('platformCollection.holding_odd_numbers') }}:</h4>
              <p>{{ totalObj.totalNum }}</p>
            </div>
            <div>
              <h4>{{ $t('platformCollection.succed_order_number') }}:</h4>
              <p>{{ totalObj.dayCount }}</p>
            </div>
            <div>
              <h4>{{ $t('platformCollection.succed_amount_number') }}:</h4>
              <p>{{ totalObj.dayAmount }}</p>
            </div>
            <div>
              <h4>{{ $t('platformCollection.extension_order_number') }}:</h4>
              <p>{{ totalObj.dayExCount }}</p>
            </div>
            <div>
              <h4>{{ $t('platformCollection.extension_amount_number') }}:</h4>
              <p>{{ totalObj.dayExAmount }}</p>
            </div>
          </div>
        </template>
      </a-table>
    </div>
    <div style="margin-top: 15px; text-align: right">
      <v-pagination
        v-if="total"
        :page-num="form.pageNum"
        :page-size="form.pageSize"
        :total="total"
        @change="handleTableChange"
      />
    </div>
    <!-- <div style="width:100%; display:flex;justify-content: end;">
    <a-pagination
      show-size-changer
      :current="queryParam.pageNum"
      :pageSize="3"
      :total="queryParam.total"
      @change="pageChange"
      @showSizeChange="onShowSizeChange"
    />
    </div> -->
  </div>
</template>
<script>
import { collectionPerformanceByDay, collectionPerformanceTotalByDay } from '@/webpublicapi/order'
import { getCollectionListDepartment } from '@/webpublicapi/group'
import { getSysGroup, getColUserListByGroupId } from '@/webpublicapi/platformCollection'
import moment from 'moment'
import { mapActions } from 'vuex'
import { exportFileByPost } from '@/api/exportFile'
import { filterObj } from '@/utils/util'
import { getAllNormalConfig } from '@/webpublicapi/normalConfig'
const I18N_KEY = {
  ORDER: 'order.',
  CUSTOMER: 'customer.',
  COLLECTION: 'collection.',
}
export default {
  name: 'CollectionCountByDay',
  data() {
    return {
      I18N_KEY,
      loading: false,
      queryParam: {
        date: [moment(), moment()],
        normalConfigId: null,
        departmentId: null,
        groupId: null,
        userId: null,
        // pageNum: 1,
        // pageSize: 10,
        // total: 0,
        dateStart: '',
        dateEnd: '',
      },
      // 分页参数
      form: {
        pageNum: 1,
        pageSize: 10,
      },
      total: 0,
      selected: null,
      groupList: [],
      departmentList: [],
      userList: [],
      normalConfigList: [],
      defaultNormalConfig: undefined,
      dataSource: [],
      columns: [
        {
          title: this.$t('platformCollection.date'),
          dataIndex: 'dSettleTime',
          key: 'dSettleTime',
        },
        {
          title: this.$t('platformCollection.account_age'),
          dataIndex: 'normalConfigName',
          key: 'normalConfigName',
        },
        {
          title: this.$t('platformCollection.department_name'),
          dataIndex: 'departmentName',
          key: 'departmentName',
        },
        {
          title: this.$t('platformCollection.group_name'),
          dataIndex: 'groupName',
          key: 'groupName',
        },
        {
          title: this.$t('platformCollection.name_of_collector'),
          dataIndex: 'userName',
          key: 'userName',
        },
        {
          title: this.$t('platformCollection.holding_odd_numbers'),
          dataIndex: 'totalNum',
          key: 'totalNum',
        },
        {
          title: this.$t('platformCollection.day_succed_order_number'),
          dataIndex: 'dayCount',
          key: 'dayCount',
        },
        {
          title: this.$t('platformCollection.day_succed_amount_number'),
          dataIndex: 'dayAmount',
          key: 'dayAmount',
        },
        {
          title: this.$t('platformCollection.day_extension_order_number'),
          dataIndex: 'dayExCount',
          key: 'dayExCount',
        },
        {
          title: this.$t('platformCollection.day_extension_amount_number'),
          dataIndex: 'dayExAmount',
          key: 'dayExAmount',
        },
        {
          title: this.$t('platformCollection.day_succed_count_rate'),
          dataIndex: 'dayCountRate',
          key: 'dayCountRate',
        },
      ],
      totalObj: {
        totalNum: 0,
        dayCount: 0,
        dayAmount: 0,
        dayExCount: 0,
        dayExAmount: 0,
      },
    }
  },
  created() {
    // 催收员姓名
    getCollectionListDepartment().then((res) => {
      this.departmentList = res.data || []
      // this.loadData()
    })
    getAllNormalConfig().then((res) => {
      this.normalConfigList = res.data || []
      // this.normalConfigList.forEach(item => {
      //   console.log(item,'12312312313')
      //   if (item.name === 't0') {
      //     this.defaultNormalConfig = item
      //     this.queryParam.normalConfigId = item.id
      //   }
      // })
    })
  },
  mounted() {},
  methods: {
    tableMethod() {},
    handleChange([start, end]) {
      if (start && !end) {
        this.selected = start
      } else {
        this.selected = null
      }
    },
    handleBlur() {
      this.selected = null
    },
    disabledDate(current) {
      if (!this.selected) return false
      return current.diff(this.selected, 'days') > 30 || current.diff(this.selected, 'days') < -30
    },
    transformTime(time) {
      return moment(time).format('YYYY-MM-DD')
    },
    pageChange(page, pageSize) {
      this.queryParam.pageNum = page
      this.queryParam.pageSize = pageSize
      this.loadData()
    },
    onShowSizeChange(page, pageSize) {
      this.queryParam.pageNum = page
      this.queryParam.pageSize = pageSize
      this.loadData()
    },
    handleTableChange(pageNum, pageSize) {
      this.form.pageNum = pageNum
      this.form.pageSize = pageSize
      this.loadData()
    },
    loadData(pageNu) {
      if (pageNu) {
        this.form.pageNum = pageNu
      }
      const date = this.queryParam.date
      if (!date[0] || !date[0]) return this.$message.warning('请选择起止日期')
      ;(this.queryParam.dateStart = this.transformTime(date[0])),
        (this.queryParam.dateEnd = this.transformTime(date[1])),
        (this.loading = true),
        (this.queryParam.pageNum = this.form.pageNum)
      this.queryParam.pageSize = this.form.pageSize
      collectionPerformanceByDay(this.queryParam).then((res) => {
        this.dataSource = res.data.list.map((item, index) => {
          item.key = index
          return item
        })
        this.form.pageNum = res.data.pageNum
        this.form.pageSize = res.data.pageSize
        this.total = res.data.total
        this.loading = false
      })
      let obj = JSON.parse(JSON.stringify(this.queryParam))
      delete obj.pageNum
      delete obj.pageSize
      collectionPerformanceTotalByDay(obj).then((res) => {
        if (null == res.data) {
          this.totalObj.totalNum = 0
          this.totalObj.dayCount = 0
          this.totalObj.dayAmount = 0
          this.totalObj.dayExCount = 0
          this.totalObj.dayExAmount = 0
        } else {
          this.totalObj = res.data
        }
      })
    },
    onChangeOne(value) {
      console.log(value)
      getSysGroup({ departmentId: value }).then((res) => {
        this.groupList = res.data || []
        this.queryParam.groupId = null
      })
    },
    onChangeTwo(value) {
      getColUserListByGroupId({ groupId: value }).then((res) => {
        this.userList = res.data || []
        this.queryParam.userId = null
      })
    },
    getQueryParams() {
      const { date } = this.queryParam
      const data = {
        ...this.queryParam,
        dateStart: date && date.length ? this.transformTime(date[0]) : '',
        dateEnd: date && date.length ? this.transformTime(date[1]) : '',
      }
      delete data.date
      var param = Object.assign({}, data)
      return filterObj(param)
    },
    async downLoadData() {
      var params = this.getQueryParams() // 查询条件
      this.loading = true
      // console.log(file.fileUrl)
      try {
        const result = await exportFileByPost(
          `/api/web/webpublic/collectionReplaceTask/collectionPerformanceByDayExcel`,
          params,
          '催收绩效日报表.xlsx'
        )
        if (result instanceof Error) {
          this.$message.error(result.message)
        }
      } catch (error) {
        this.$message.error(error.message)
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
<style scoped>
.totalBox {
  width: 100%;
  display: flex;
  margin-top: 20px;
}

.totalBox div {
  margin-right: 50px;
  display: flex;
}

.totalBox h4,
.totalBox p {
  /* font-weight: 600; */
}
</style>
